import {User, Reward, RewardOrder} from "@irati/types"
import firstnameLastname from "@irati/identity/helpers/user/firstnameLastname"
import {FormatMessage} from "@irati/utils/lang/types"
import {WhoRewardedRewardTypes, WhoRewardedTypes} from "@irati/reward/enums/WhoRewardedTypes"
import {RewardDescriptionProps} from "@irati-web/recognition/src/components/WhoRewarded/DisplayDescription"

export const getUserText = (formatMessage: FormatMessage, userType: WhoRewardedTypes, user: User): string => {
  const addedBy = formatMessage({id: "recognition.whoRewarded.addedBy"})

  const sender = userType === WhoRewardedTypes.SENDER ? formatMessage({id: "recognition.whoRewarded.you"}) : firstnameLastname(user)

  return `${addedBy} ${sender}`
}

export const getRewardText = (rewardType: WhoRewardedRewardTypes, formatMessage: FormatMessage): string => {
  if (rewardType === WhoRewardedRewardTypes.CREDIT_REWARD) {
    return formatMessage({id: "recognition.whoRewarded.credit"})
  }
  return formatMessage({id: "recognition.whoRewarded.reward"})
}

export const getRewardDescription = (
  reward: Reward,
  rewardOrder: RewardOrder,
  rewardType: WhoRewardedRewardTypes
): RewardDescriptionProps => {
  switch (rewardType) {
    case WhoRewardedRewardTypes.CUSTOM_OLD_REWARD:
    case WhoRewardedRewardTypes.OLD_REWARD:
      return {text: reward.desc}
    case WhoRewardedRewardTypes.NEW_REWARD:
      return {
        text: rewardOrder.reward.header,
        costPerUnit: rewardOrder.costPerUnit
      }
    case WhoRewardedRewardTypes.CUSTOM_NEW_REWARD:
      return {text: rewardOrder.custom}
    case WhoRewardedRewardTypes.CREDIT_REWARD:
      return {text: "credit amount"}
    // @todo add credit amount
    default:
      return {text: " "}
  }
}
